const form = document.querySelector('#signup-form');

if (form) {
  const emailEl = form.querySelector('#signup-email');
  const emailLabelEl = form.querySelector('.signup-email-label');
  const messageEl = form.querySelector('#signup-message');
  const submitEl = form.querySelector('button[type="submit"]');

  const validationMessages = {
    required: 'Please enter your email address.',
    invalid: 'Please enter a valid email address.',
  };

  const errorMessages = {
    VALIDATION_ERROR: validationMessages.invalid,
    EMAIL_UNDELIVERABLE: 'That email address does not seem to be deliverable.',
    RATE_LIMITED: 'Too many attempts. Please try again in a moment.',
    BOT_CHECK_FAILED: 'We could not verify your submission. Please try again.',
  };

  function clearMessage() {
    messageEl.textContent = '';
    messageEl.classList.add('hidden');
    messageEl.classList.remove('is-error', 'is-success');
  }

  function showMessage(text, state) {
    messageEl.textContent = text;
    messageEl.classList.remove('hidden', 'is-error', 'is-success');
    messageEl.classList.add(state === 'success' ? 'is-success' : 'is-error');
  }

  function getValidationMessage() {
    if (emailEl.validity.valueMissing) {
      return validationMessages.required;
    }

    if (!emailEl.validity.valid) {
      return validationMessages.invalid;
    }

    return '';
  }

  function setFieldInvalid(hasError) {
    emailLabelEl.classList.toggle('has-error', hasError);

    if (hasError) {
      emailEl.setAttribute('aria-invalid', 'true');
      return;
    }

    emailEl.removeAttribute('aria-invalid');
  }

  function toggleSubmit(disable) {
    if (disable) {
      submitEl.setAttribute('disabled', 'true');
      submitEl.setAttribute('aria-disabled', 'true');
    } else {
      submitEl.removeAttribute('disabled');
      submitEl.removeAttribute('aria-disabled');
    }
  }

  emailEl.addEventListener('blur', function () {
    const validationMessage = getValidationMessage();
    setFieldInvalid(Boolean(validationMessage));

    if (validationMessage) {
      showMessage(validationMessage, 'error');
    }
  });

  emailEl.addEventListener('input', function () {
    const validationMessage = getValidationMessage();

    if (!validationMessage) {
      setFieldInvalid(false);
      if (messageEl.classList.contains('is-error')) {
        clearMessage();
      }
      return;
    }

    if (emailLabelEl.classList.contains('has-error')) {
      setFieldInvalid(true);
      showMessage(validationMessage, 'error');
    }
  });

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();

    const validationMessage = getValidationMessage();

    if (validationMessage) {
      setFieldInvalid(true);
      showMessage(validationMessage, 'error');
      emailEl.focus();
      return;
    }

    setFieldInvalid(false);
    clearMessage();
    toggleSubmit(true);

    fetch(form.action, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        campaignId: form.campaignId.value,
        email: emailEl.value.trim(),
        tags: ['newsletter'],
        hp: form.hp.value,
      }),
    })
      .then(async (res) => {
        if (res.ok) {
          form.reset();
          setFieldInvalid(false);
          showMessage('Thanks for subscribing. Please check your inbox if confirmation is needed.', 'success');
          return;
        }

        const data = await res.json().catch(() => ({}));
        const code = Array.isArray(data.error) ? data.error[0] && data.error[0].code : data.code;
        showMessage(errorMessages[code] || 'Something went wrong. Please try again later.', 'error');
      })
      .catch(() => {
        showMessage('Something went wrong. Please try again later.', 'error');
      })
      .finally(() => {
        toggleSubmit(false);
      });
  });
}
